import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M4 17L17 4",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M2.87878 8.38383C2.82821 8.26582 2.73418 8.17179 2.61617 8.12122L1.07234 7.45957C0.668282 7.28641 0.668282 6.71359 1.07234 6.54043L2.61617 5.87878C2.73418 5.82821 2.82821 5.73418 2.87878 5.61617L3.54043 4.07234C3.71359 3.66828 4.28641 3.66828 4.45957 4.07234L5.12122 5.61617C5.17179 5.73418 5.26582 5.82821 5.38383 5.87878L6.92766 6.54043C7.33172 6.71359 7.33172 7.28641 6.92766 7.45957L5.38383 8.12122C5.26582 8.17179 5.17179 8.26582 5.12122 8.38383L4.45957 9.92766C4.28641 10.3317 3.71359 10.3317 3.54043 9.92766L2.87878 8.38383Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M14.8788 17.3838C14.8282 17.2658 14.7342 17.1718 14.6162 17.1212L13.0723 16.4596C12.6683 16.2864 12.6683 15.7136 13.0723 15.5404L14.6162 14.8788C14.7342 14.8282 14.8282 14.7342 14.8788 14.6162L15.5404 13.0723C15.7136 12.6683 16.2864 12.6683 16.4596 13.0723L17.1212 14.6162C17.1718 14.7342 17.2658 14.8282 17.3838 14.8788L18.9277 15.5404C19.3317 15.7136 19.3317 16.2864 18.9277 16.4596L17.3838 17.1212C17.2658 17.1718 17.1718 17.2658 17.1212 17.3838L16.4596 18.9277C16.2864 19.3317 15.7136 19.3317 15.5404 18.9277L14.8788 17.3838Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M8.79727 3.3603C8.76693 3.28949 8.71051 3.23307 8.6397 3.20273L7.6434 2.77574C7.40097 2.67184 7.40097 2.32816 7.6434 2.22426L8.6397 1.79727C8.71051 1.76693 8.76693 1.71051 8.79727 1.6397L9.22426 0.643402C9.32816 0.40097 9.67184 0.400969 9.77574 0.643402L10.2027 1.6397C10.2331 1.71051 10.2895 1.76693 10.3603 1.79727L11.3566 2.22426C11.599 2.32816 11.599 2.67184 11.3566 2.77574L10.3603 3.20273C10.2895 3.23307 10.2331 3.28949 10.2027 3.3603L9.77574 4.3566C9.67184 4.59903 9.32816 4.59903 9.22426 4.3566L8.79727 3.3603Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }